import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
})
export class DialogComponent implements OnInit {
    @Input() heading: string = '';
    @Input() messages: string[] = [];
    @Input() messageTitle: string[] = [];
    @Input() confirmation: boolean = false;

    @Output() close: EventEmitter<any> = new EventEmitter();
    constructor(public dialogRef: MatDialogRef<DialogComponent>) {}

    ngOnInit(): void {}
    sureDialogue(){
      this.dialogRef.close(true);
      this.close.emit();
    }
    closeDialogue() {
      this.dialogRef.close(false);
      this.close.emit();
    }
}
